var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jobs_wrapper" }, [
    _c("div", { class: { overlay_setting: _vm.isLoadingData } }, [
      _c("i", { class: { loadding_setting: _vm.isLoadingData } })
    ]),
    !_vm.isLoadingData
      ? _c(
          "div",
          [
            _c(
              "h1",
              {
                staticClass: "jobs_page_title",
                style: { color: _vm.colorSetting.pageText }
              },
              _vm._l(_vm.headingSettings, function(headingSetting, index) {
                return _c(
                  "span",
                  { key: index },
                  [
                    _vm.jobDetail[headingSetting.name] &&
                    _vm.jobResourceFields[headingSetting.name]
                      ? [
                          _vm.isPreviousItemHaveData(
                            _vm.jobDetail,
                            headingSetting.name,
                            index,
                            _vm.headingSettings[index ? index - 1 : index].name,
                            _vm.headingSettings
                          )
                            ? _c("span", [
                                _vm._v("\n            /\n          ")
                              ])
                            : _vm._e(),
                          _vm.jobResourceFields[headingSetting.name].name ===
                          "company_id"
                            ? _c("span", [
                                _vm.jobDetail[_vm.companyPublicSetting] === 1
                                  ? _c("span", [
                                      _vm.companyData.name
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.companyData.name) +
                                                "\n              "
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.searchJobLabelsProperty
                                                    .NAME_COMPANY_UNREGISTER
                                                ) +
                                                "\n              "
                                            )
                                          ])
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.searchJobLabelsProperty
                                              .NAME_COMPANY_PRIVATE
                                          ) +
                                          "\n            "
                                      )
                                    ])
                              ])
                            : _vm.jobResourceFields[headingSetting.name]
                                .type === "free_email"
                            ? _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.jobDetail[headingSetting.name].data
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm.jobResourceFields[headingSetting.name]
                                .type === "url"
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.jobDetail[headingSetting.name]) +
                                    "\n          "
                                )
                              ])
                            : _vm.TYPE_OF_SINGLE_SELECT.includes(
                                _vm.jobResourceFields[headingSetting.name].type
                              ) &&
                              _vm.jobResourceFields[headingSetting.name]
                                .master_name &&
                              _vm.jobResourceFields[headingSetting.name].name
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.getSingleSelectValue(
                                        _vm.jobResourceFields[
                                          headingSetting.name
                                        ].master_name,
                                        _vm.jobDetail[headingSetting.name]
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm.TYPE_OF_MULTI_SELECT.includes(
                                _vm.jobResourceFields[headingSetting.name].type
                              ) &&
                              _vm.jobResourceFields[headingSetting.name]
                                .master_name &&
                              _vm.jobResourceFields[headingSetting.name].name
                            ? _c(
                                "span",
                                _vm._l(
                                  _vm.getMultiSelectValue(
                                    _vm.jobResourceFields[headingSetting.name]
                                      .master_name,
                                    _vm.jobDetail[headingSetting.name]
                                  ),
                                  function(value, index) {
                                    return _c("span", { key: index }, [
                                      index !== 0
                                        ? _c("span", [_vm._v(", ")])
                                        : _vm._e(),
                                      _c("span", [_vm._v(_vm._s(value))])
                                    ])
                                  }
                                ),
                                0
                              )
                            : _vm.FORMAT_DATE.includes(
                                _vm.jobResourceFields[headingSetting.name].type
                              )
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.getDatetimeString(
                                        _vm.jobResourceFields[
                                          headingSetting.name
                                        ].type,
                                        _vm.jobDetail[headingSetting.name]
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm.jobResourceFields[headingSetting.name]
                                .name === "staff_id"
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.staffData.name) +
                                    "\n          "
                                )
                              ])
                            : _vm.TYPE_OF_NUMBER.includes(
                                _vm.jobResourceFields[headingSetting.name].type
                              )
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.formatNumberByStep(
                                        _vm.jobDetail[headingSetting.name],
                                        _vm.jobResourceFields[
                                          headingSetting.name
                                        ].step
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.jobDetail[headingSetting.name]) +
                                    "\n          "
                                )
                              ]),
                          _vm.jobResourceFields[headingSetting.name].unit
                            ? _c(
                                "span",
                                {
                                  staticClass: "ml-1",
                                  class: {
                                    label_unit_item_long:
                                      _vm.jobResourceFields[headingSetting.name]
                                        .unit.length >
                                      _vm.userConfig.UNIT_LENGTH,
                                    label_unit_item:
                                      _vm.jobResourceFields[headingSetting.name]
                                        .unit.length <=
                                      _vm.userConfig.UNIT_LENGTH
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.jobResourceFields[headingSetting.name]
                                        .unit
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              }),
              0
            ),
            _vm._l(_vm.bodySettings, function(bodySetting, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "jobs_detail_text",
                  style: { color: _vm.colorSetting.pageText }
                },
                [
                  _vm.jobDetail[bodySetting.name] &&
                  _vm.jobResourceFields[bodySetting.name]
                    ? [
                        _vm.jobResourceFields[bodySetting.name].name ===
                        "company_id"
                          ? _c("span", [
                              _vm.jobDetail[_vm.companyPublicSetting] === 1
                                ? _c("span", [
                                    _vm.companyData.name
                                      ? _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.companyData.name) +
                                              "\n            "
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.searchJobLabelsProperty
                                                  .NAME_COMPANY_UNREGISTER
                                              ) +
                                              "\n            "
                                          )
                                        ])
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.searchJobLabelsProperty
                                            .NAME_COMPANY_PRIVATE
                                        ) +
                                        "\n          "
                                    )
                                  ])
                            ])
                          : _vm.jobResourceFields[bodySetting.name].type ===
                            "free_email"
                          ? _c("span", [
                              _c(
                                "a",
                                {
                                  style: { color: _vm.colorSetting.linkText },
                                  attrs: {
                                    href:
                                      "mailto:" +
                                      _vm.jobDetail[bodySetting.name].data
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.jobDetail[bodySetting.name].data
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            ])
                          : _vm.jobResourceFields[bodySetting.name].type ===
                            "url"
                          ? _c("span", [
                              _c(
                                "a",
                                {
                                  staticStyle: { "text-decoration": "none" },
                                  style: { color: _vm.colorSetting.linkText },
                                  attrs: {
                                    href: _vm.jobDetail[bodySetting.name],
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.jobDetail[bodySetting.name]) +
                                      "\n          "
                                  )
                                ]
                              )
                            ])
                          : _vm.TYPE_OF_SINGLE_SELECT.includes(
                              _vm.jobResourceFields[bodySetting.name].type
                            ) &&
                            _vm.jobResourceFields[bodySetting.name]
                              .master_name &&
                            _vm.jobResourceFields[bodySetting.name].name
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.getSingleSelectValue(
                                      _vm.jobResourceFields[bodySetting.name]
                                        .master_name,
                                      _vm.jobDetail[bodySetting.name]
                                    )
                                  ) +
                                  "\n        "
                              )
                            ])
                          : _vm.TYPE_OF_MULTI_SELECT.includes(
                              _vm.jobResourceFields[bodySetting.name].type
                            ) &&
                            _vm.jobResourceFields[bodySetting.name]
                              .master_name &&
                            _vm.jobResourceFields[bodySetting.name].name
                          ? _c(
                              "span",
                              _vm._l(
                                _vm.getMultiSelectValue(
                                  _vm.jobResourceFields[bodySetting.name]
                                    .master_name,
                                  _vm.jobDetail[bodySetting.name]
                                ),
                                function(value, index) {
                                  return _c("span", { key: index }, [
                                    index !== 0
                                      ? _c("span", [_vm._v(", ")])
                                      : _vm._e(),
                                    _c("span", [_vm._v(_vm._s(value))])
                                  ])
                                }
                              ),
                              0
                            )
                          : _vm.FORMAT_DATE.includes(
                              _vm.jobResourceFields[bodySetting.name].type
                            )
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.getDatetimeString(
                                      _vm.jobResourceFields[bodySetting.name]
                                        .type,
                                      _vm.jobDetail[bodySetting.name]
                                    )
                                  ) +
                                  "\n        "
                              )
                            ])
                          : _vm.jobResourceFields[bodySetting.name].name ===
                            "staff_id"
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.staffData.name) +
                                  "\n        "
                              )
                            ])
                          : _vm.TYPE_OF_NUMBER.includes(
                              _vm.jobResourceFields[bodySetting.name].type
                            )
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.formatNumberByStep(
                                      _vm.jobDetail[bodySetting.name],
                                      _vm.jobResourceFields[bodySetting.name]
                                        .step
                                    )
                                  ) +
                                  "\n        "
                              )
                            ])
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "pre-margin-bottom line_break_setting_text"
                              },
                              [_vm._v(_vm._s(_vm.jobDetail[bodySetting.name]))]
                            ),
                        _vm.jobResourceFields[bodySetting.name].unit
                          ? _c(
                              "span",
                              {
                                staticClass: "ml-1",
                                class: {
                                  label_unit_item_long:
                                    _vm.jobResourceFields[bodySetting.name].unit
                                      .length > _vm.userConfig.UNIT_LENGTH,
                                  label_unit_item:
                                    _vm.jobResourceFields[bodySetting.name].unit
                                      .length <= _vm.userConfig.UNIT_LENGTH
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.jobResourceFields[bodySetting.name].unit
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            }),
            _vm._l(_vm.categories, function(category, cIndex) {
              return [
                category &&
                !category.categoryDeleted &&
                !_vm.isEmptyCategory(cIndex)
                  ? [
                      _c(
                        "h2",
                        {
                          staticClass: "jobs_category_title",
                          style: {
                            color: _vm.colorSetting.pageText,
                            borderLeftColor: _vm.colorSetting.keyColor
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(category.categoryName) +
                              "\n        "
                          )
                        ]
                      ),
                      _c("div", { staticClass: "jobs_table_wrapper" }, [
                        _c("table", { staticClass: "jobs_detail_table" }, [
                          _c(
                            "tbody",
                            { staticClass: "jobs_detail_table_body" },
                            [
                              _vm._l(category.item, function(item, index) {
                                return [
                                  !item.resourceField[0].name.startsWith(
                                    _vm.jobSettingProperty.ITEM_COMPANY_MODIFY
                                  ) &&
                                  _vm.jobDetail[item.resourceField[0].name] &&
                                  ((item.resourceField[0].name ===
                                    "company_id" &&
                                    _vm.jobDetail[_vm.companyPublicSetting] ===
                                      1 &&
                                    _vm.companyData.name) ||
                                    item.resourceField[0].name !== "company_id")
                                    ? _c(
                                        "tr",
                                        {
                                          key: item.resourceField[0].name,
                                          staticClass: "jobs_detail_table_rows"
                                        },
                                        [
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "jobs_detail_table_head",
                                              style: [
                                                {
                                                  backgroundColor:
                                                    _vm.colorSetting.subColor
                                                },
                                                index === 0
                                                  ? {
                                                      border:
                                                        "1px solid" +
                                                        _vm.colorSetting
                                                          .borderColor
                                                    }
                                                  : {
                                                      borderLeft:
                                                        "1px solid" +
                                                        _vm.colorSetting
                                                          .borderColor,
                                                      borderRight:
                                                        "1px solid" +
                                                        _vm.colorSetting
                                                          .borderColor,
                                                      borderBottom:
                                                        "1px solid" +
                                                        _vm.colorSetting
                                                          .borderColor
                                                    }
                                              ]
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "setting_word_break",
                                                  style: {
                                                    color:
                                                      _vm.colorSetting.pageText
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.itemName) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "jobs_detail_table_cell word-break",
                                              style: {
                                                borderTop:
                                                  "1px solid" +
                                                  _vm.colorSetting.borderColor,
                                                borderRight:
                                                  "1px solid" +
                                                  _vm.colorSetting.borderColor,
                                                borderBottom:
                                                  "1px solid" +
                                                  _vm.colorSetting.borderColor
                                              }
                                            },
                                            [
                                              item.resourceField[0].name ===
                                              "company_id"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.companyData.name
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : item.resourceField[0].type ===
                                                  "free_email"
                                                ? _c("span", [
                                                    _c(
                                                      "a",
                                                      {
                                                        style: {
                                                          color:
                                                            _vm.colorSetting
                                                              .linkText
                                                        },
                                                        attrs: {
                                                          href:
                                                            "mailto:" +
                                                            _vm.jobDetail[
                                                              item
                                                                .resourceField[0]
                                                                .name
                                                            ].data
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.jobDetail[
                                                                item
                                                                  .resourceField[0]
                                                                  .name
                                                              ].data
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : item.resourceField[0].type ===
                                                  "url"
                                                ? _c("span", [
                                                    _c(
                                                      "a",
                                                      {
                                                        style: {
                                                          color:
                                                            _vm.colorSetting
                                                              .linkText
                                                        },
                                                        attrs: {
                                                          href:
                                                            _vm.jobDetail[
                                                              item
                                                                .resourceField[0]
                                                                .name
                                                            ],
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.jobDetail[
                                                                item
                                                                  .resourceField[0]
                                                                  .name
                                                              ]
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                    item.resourceField[0].type
                                                  ) &&
                                                  item.resourceField[0]
                                                    .master_name &&
                                                  item.resourceField[0].name
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getSingleSelectValue(
                                                            item
                                                              .resourceField[0]
                                                              .master_name,
                                                            _vm.jobDetail[
                                                              item
                                                                .resourceField[0]
                                                                .name
                                                            ]
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : _vm.TYPE_OF_MULTI_SELECT.includes(
                                                    item.resourceField[0].type
                                                  ) &&
                                                  item.resourceField[0]
                                                    .master_name &&
                                                  item.resourceField[0].name
                                                ? _c(
                                                    "span",
                                                    _vm._l(
                                                      _vm.getMultiSelectValue(
                                                        item.resourceField[0]
                                                          .master_name,
                                                        _vm.jobDetail[
                                                          item.resourceField[0]
                                                            .name
                                                        ]
                                                      ),
                                                      function(value, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            index !== 0
                                                              ? _c("span", [
                                                                  _vm._v(", ")
                                                                ])
                                                              : _vm._e(),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(value)
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm.FORMAT_DATE.includes(
                                                    item.resourceField[0].type
                                                  )
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getDatetimeString(
                                                            item
                                                              .resourceField[0]
                                                              .type,
                                                            _vm.jobDetail[
                                                              item
                                                                .resourceField[0]
                                                                .name
                                                            ]
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : item.resourceField[0].name ===
                                                  "staff_id"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.staffData.name
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : item.resourceField[0].type ===
                                                  "textarea"
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "white-space"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.jobDetail[
                                                            item
                                                              .resourceField[0]
                                                              .name
                                                          ]
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm.TYPE_OF_NUMBER.includes(
                                                    item.resourceField[0].type
                                                  )
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.formatNumberByStep(
                                                            _vm.jobDetail[
                                                              item
                                                                .resourceField[0]
                                                                .name
                                                            ],
                                                            item
                                                              .resourceField[0]
                                                              .step
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.jobDetail[
                                                          item.resourceField[0]
                                                            .name
                                                        ]
                                                      )
                                                    )
                                                  ]),
                                              item.resourceField[0].unit
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "ml-1",
                                                      class: {
                                                        label_unit_item_long:
                                                          item.resourceField[0]
                                                            .unit.length >
                                                          _vm.userConfig
                                                            .UNIT_LENGTH,
                                                        label_unit_item:
                                                          item.resourceField[0]
                                                            .unit.length <=
                                                          _vm.userConfig
                                                            .UNIT_LENGTH
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.resourceField[0]
                                                            .unit
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  item.resourceField[0].name.startsWith(
                                    _vm.jobSettingProperty.ITEM_COMPANY_MODIFY
                                  ) &&
                                  _vm.companyData[
                                    item.resourceField[0].name.substring(8)
                                  ] &&
                                  _vm.jobDetail[_vm.companyPublicSetting] === 1
                                    ? _c(
                                        "tr",
                                        {
                                          key: item.resourceField[0].name,
                                          staticClass: "jobs_detail_table_rows"
                                        },
                                        [
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "jobs_detail_table_head",
                                              style: [
                                                {
                                                  backgroundColor:
                                                    _vm.colorSetting.subColor
                                                },
                                                index === 0
                                                  ? {
                                                      border:
                                                        "1px solid" +
                                                        _vm.colorSetting
                                                          .borderColor
                                                    }
                                                  : {
                                                      borderLeft:
                                                        "1px solid" +
                                                        _vm.colorSetting
                                                          .borderColor,
                                                      borderRight:
                                                        "1px solid" +
                                                        _vm.colorSetting
                                                          .borderColor,
                                                      borderBottom:
                                                        "1px solid" +
                                                        _vm.colorSetting
                                                          .borderColor
                                                    }
                                              ]
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "setting_word_break",
                                                  style: {
                                                    color:
                                                      _vm.colorSetting.pageText
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.itemName) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "jobs_detail_table_cell word-break",
                                              style: {
                                                borderTop:
                                                  "1px solid" +
                                                  _vm.colorSetting.borderColor,
                                                borderRight:
                                                  "1px solid" +
                                                  _vm.colorSetting.borderColor,
                                                borderBottom:
                                                  "1px solid" +
                                                  _vm.colorSetting.borderColor
                                              }
                                            },
                                            [
                                              item.resourceField[0].type ===
                                              "free_email"
                                                ? _c("span", [
                                                    _c(
                                                      "a",
                                                      {
                                                        style: {
                                                          color:
                                                            _vm.colorSetting
                                                              .linkText
                                                        },
                                                        attrs: {
                                                          href:
                                                            "mailto:" +
                                                            _vm.companyData[
                                                              item.resourceField[0].name.substring(
                                                                8
                                                              )
                                                            ].data
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.companyData[
                                                                item.resourceField[0].name.substring(
                                                                  8
                                                                )
                                                              ].data
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : item.resourceField[0].type ===
                                                  "url"
                                                ? _c("span", [
                                                    _c(
                                                      "a",
                                                      {
                                                        style: {
                                                          color:
                                                            _vm.colorSetting
                                                              .linkText
                                                        },
                                                        attrs: {
                                                          href:
                                                            _vm.companyData[
                                                              item.resourceField[0].name.substring(
                                                                8
                                                              )
                                                            ],
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.companyData[
                                                                item.resourceField[0].name.substring(
                                                                  8
                                                                )
                                                              ]
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                    item.resourceField[0].type
                                                  ) &&
                                                  item.resourceField[0]
                                                    .master_name &&
                                                  item.resourceField[0].name
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getSingleSelectValue(
                                                            item
                                                              .resourceField[0]
                                                              .master_name,
                                                            _vm.companyData[
                                                              item.resourceField[0].name.substring(
                                                                8
                                                              )
                                                            ]
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : _vm.TYPE_OF_MULTI_SELECT.includes(
                                                    item.resourceField[0].type
                                                  ) &&
                                                  item.resourceField[0]
                                                    .master_name &&
                                                  item.resourceField[0].name
                                                ? _c(
                                                    "span",
                                                    _vm._l(
                                                      _vm.getMultiSelectValue(
                                                        item.resourceField[0]
                                                          .master_name,
                                                        _vm.companyData[
                                                          item.resourceField[0].name.substring(
                                                            8
                                                          )
                                                        ]
                                                      ),
                                                      function(value, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            index !== 0
                                                              ? _c("span", [
                                                                  _vm._v(", ")
                                                                ])
                                                              : _vm._e(),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(value)
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm.FORMAT_DATE.includes(
                                                    item.resourceField[0].type
                                                  )
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getDatetimeString(
                                                            item
                                                              .resourceField[0]
                                                              .type,
                                                            _vm.companyData[
                                                              item.resourceField[0].name.substring(
                                                                8
                                                              )
                                                            ]
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : item.resourceField[0].type ===
                                                  "textarea"
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "white-space"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.companyData[
                                                            item.resourceField[0].name.substring(
                                                              8
                                                            )
                                                          ]
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm.TYPE_OF_NUMBER.includes(
                                                    item.resourceField[0].type
                                                  )
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.formatNumberByStep(
                                                            _vm.companyData[
                                                              item.resourceField[0].name.substring(
                                                                8
                                                              )
                                                            ],
                                                            item
                                                              .resourceField[0]
                                                              .step
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : _vm.isObjectDataHasValue(
                                                    _vm.companyData[
                                                      item.resourceField[0].name.substring(
                                                        8
                                                      )
                                                    ]
                                                  )
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.companyData[
                                                          item.resourceField[0].name.substring(
                                                            8
                                                          )
                                                        ].data
                                                      )
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.companyData[
                                                          item.resourceField[0].name.substring(
                                                            8
                                                          )
                                                        ]
                                                      )
                                                    )
                                                  ]),
                                              item.resourceField[0].unit
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "ml-1",
                                                      class: {
                                                        label_unit_item_long:
                                                          item.resourceField[0]
                                                            .unit.length >
                                                          _vm.userConfig
                                                            .UNIT_LENGTH,
                                                        label_unit_item:
                                                          item.resourceField[0]
                                                            .unit.length <=
                                                          _vm.userConfig
                                                            .UNIT_LENGTH
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.resourceField[0]
                                                            .unit
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    ]
                  : _vm._e()
              ]
            }),
            _vm.commonSetting
              ? _c("div", { staticClass: "jobs_btn_box" }, [
                  _vm.commonSetting.jobInquiryUrl
                    ? _c(
                        "button",
                        {
                          staticClass: "jobs_btn_primary",
                          style: {
                            color: _vm.colorSetting.mainButtonText,
                            backgroundColor: _vm.colorSetting.mainButton,
                            border: "1px solid" + _vm.colorSetting.borderColor
                          },
                          on: { click: _vm.redirectToContact }
                        },
                        [
                          _vm.button.contactBtn === ""
                            ? _c("span", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.searchJobLabelsProperty.BUTTON_CONTACT
                                    ) +
                                    "\n        "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.button.contactBtn) +
                                    "\n        "
                                )
                              ])
                        ]
                      )
                    : _vm._e(),
                  _vm.commonSetting.entryPublic
                    ? _c(
                        "button",
                        {
                          staticClass: "jobs_btn_primary",
                          style: {
                            color: _vm.colorSetting.mainButtonText,
                            backgroundColor: _vm.colorSetting.mainButton,
                            border: "1px solid" + _vm.colorSetting.borderColor
                          },
                          on: { click: _vm.applyJob }
                        },
                        [
                          _vm.button.detailBtn === ""
                            ? _c("span", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.searchJobLabelsProperty
                                        .BUTTON_APPLY_JOB
                                    ) +
                                    "\n        "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.button.detailBtn) +
                                    "\n        "
                                )
                              ])
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _c("div", { staticClass: "jobs_detail_back" }, [
              _c(
                "button",
                {
                  staticClass: "jobs_btn_secondary jobs_btn_medium",
                  style: {
                    color: _vm.colorSetting.subButtonText,
                    backgroundColor: _vm.colorSetting.subButton,
                    border: "1px solid" + _vm.colorSetting.borderColor
                  },
                  on: { click: _vm.returnToSearchTop }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.searchJobLabelsProperty.RETURN_JOB_SEARCH_TOP
                      ) +
                      "\n      "
                  )
                ]
              )
            ])
          ],
          2
        )
      : _vm._e(),
    _c("div", { ref: "ref_botton_top", staticClass: "setting_botton_top" }, [
      _c(
        "button",
        {
          staticClass: "setting_btn_primary",
          style: {
            color: _vm.colorSetting.mainButtonText,
            backgroundColor: _vm.colorSetting.mainButton,
            border: "1px solid" + _vm.colorSetting.borderColor
          },
          on: { click: _vm.onTopPage }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                stroke: "currentColor",
                fill: "currentColor",
                "stroke-width": "0",
                viewBox: "0 0 320 512",
                height: "1em",
                width: "1em"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
                }
              })
            ]
          )
        ]
      )
    ]),
    _vm.isDisplayPrint
      ? _c("div", { staticClass: "setting_btn_print" }, [
          _c(
            "button",
            {
              staticClass: "setting_btn_primary",
              style: {
                color: _vm.colorSetting.mainButtonText,
                backgroundColor: _vm.colorSetting.mainButton,
                border: "1px solid" + _vm.colorSetting.borderColor
              },
              on: {
                click: function($event) {
                  return _vm.printPage()
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "1rem",
                    height: "1rem",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "#ffffff",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                },
                [
                  _c("polyline", { attrs: { points: "6 9 6 2 18 2 18 9" } }),
                  _c("path", {
                    attrs: {
                      d:
                        "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
                    }
                  }),
                  _c("rect", {
                    attrs: { x: "6", y: "14", width: "12", height: "8" }
                  })
                ]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }